import { connect } from 'react-redux'
import * as actionCreatorData from '../../redux/actions/data-action';
import * as actionCreatorLookup from '../../redux/actions/lookup-action';

const isNumber = (evt) => {
  var iKeyCode = (evt.which) ? evt.which : evt.keyCode
  if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
      return false;

  return true;
}

const calcAge = (dob) => {
  var ageDifMs = Date.now() - new Date(dob).getTime();
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  var ageDOB = ageDate.getUTCFullYear() - 1970;

  if (ageDOB < 0)
    ageDOB = 0;

  return ageDOB;
}

export {
  isNumber,
  calcAge
}